<div class="desktop_config_icon">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{
      currentViewAll.title | translate
    }}</span>
  </div>

  <ng-container *ngIf="!isViewAll">
    <app-position-out-config
      [elementChoosing]="objectChoosing"
      [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object "
    >
    </app-position-out-config>

    <ul
      nz-menu
      nzMode="inline"
      *ngIf="!isViewAll"
    >
     <!-- Hiển thị -->
      <li
        nz-submenu
        nzTitle="{{ 'hien_thi' | translate }}"
        [(nzOpen)]="openMap.menu1.open"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
     
      
   
      <!-- Biểu tượng -->
      <li
        nz-submenu
        nzTitle="{{ 'bieu_tuong' | translate }}"
        [(nzOpen)]="openMap.menu3.menuChild.menu9"
        (nzOpenChange)="openHandler('menu9')"
      >

        <!-- nút cấu hình cho nút đã chọn hoặc nút chưa chọn(active/inactive) -->
        <div class="row " style="line-height: 1.2;">
          <span class="col-7"
            >Cấu hình nút
            {{ staticdata.is_favorited ? "đã chọn" : "chưa chọn" }}</span
          >
          <nz-switch
            class="col-5"
            [(ngModel)]="staticdata.is_favorited"
          >
          </nz-switch>
        </div>


        <div class="d-flex justify-content-between mx-1">
          <mat-icon [style.color]="class[staticdata.is_favorited ? '+icon__primary' : '-icon__primary']['color']">{{ staticdata[staticdata.is_favorited ? '+icon' : '-icon'] }}</mat-icon>
          <button
            nz-button
            nzType="default"
            (click)="openDialogChooseIcon()"
            style="border-radius: 5px"
          >
            {{ "thay_doi" | translate }}
          </button>
        </div>

        <div class="color-pick">
          <span class="title w-50">{{ "mau_bieu_tuong" | translate }}</span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class[staticdata.is_favorited ? '+icon__primary' : '-icon__primary']['color']"
            [style.backgroundColor]="class[staticdata.is_favorited ? '+icon__primary' : '-icon__primary']['color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>

        <div class="color-pick">
          <span class="title w-50">{{ "mau_nen" | translate }}</span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class[staticdata.is_favorited ? '+icon' : '-icon']['background-color']"
            [style.background]="class[staticdata.is_favorited ? '+icon' : '-icon']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>

        <!-- Kích thước -->
        <ng-container>
          <nz-row class="d-flex justify-content-between align-items-center">
            <p class="m-0">{{ "kich_thuoc" | translate }}</p>
            <nz-input-number
              [nzMin]="0"
              [nzMax]="30"
              [nzStep]="1"
              [ngStyle]="{ marginLeft: '10px' }"
              [ngModel]="class[ staticdata.is_favorited ? '+icon__primary': '-icon__primary']['font-size'] | vhnumber"
              (ngModelChange)="
                class[ staticdata.is_favorited ? '+icon__primary': '-icon__primary']['font-size'] = $event + 'px'
              "
              (nzBlur)="updateClass()"
            ></nz-input-number>
          </nz-row>
          <nz-col nzSpan="24">
            <nz-slider
              [nzMin]="0"
              [nzMax]="30"
              [nzStep]="1"
              [ngModel]="class[staticdata.is_favorited ? '+icon__primary': '-icon__primary']['font-size'] | vhnumber"
              (ngModelChange)="
                class[staticdata.is_favorited ? '+icon__primary': '-icon__primary']['font-size'] = $event + 'px'
              "
              (nzOnAfterChange)="updateClass()"
            ></nz-slider>
          </nz-col>
        </ng-container>

        <!-- Độ trong suốt -->
        <ng-container>
          <nz-row
            class="d-flex justify-content-between align-items-center"
            nzSpan="24"
          >
            <p class="m-0">{{ "do_trong_suot" | translate }}</p>
            <nz-input-number
              nzSpan="4"
              [nzMin]="0"
              [nzMax]="1"
              [ngModel]="class[staticdata.is_favorited ? '+icon__primary': '-icon__primary']['opacity']"
              (ngModelChange)="class[staticdata.is_favorited ? '+icon__primary': '-icon__primary']['opacity'] = $event"
              (nzBlur)="updateClass()"
              [nzStep]="0.1"
            ></nz-input-number>
          </nz-row>
          <nz-col nzSpan="24">
            <nz-slider
              [nzMin]="0"
              [nzMax]="1"
              [nzStep]="0.1"
              [ngModel]="class[staticdata.is_favorited ? '+icon__primary': '-icon__primary']['opacity']"
              (ngModelChange)="class[staticdata.is_favorited ? '+icon__primary': '-icon__primary']['opacity'] = $event"
              (nzOnAfterChange)="updateClass()"
            ></nz-slider>
          </nz-col>
        </ng-container>

        <!-- Độ nhòe -->
        <ng-container>
          <nz-row
            class="d-flex justify-content-between align-items-center"
            nzSpan="24"
          >
            <p class="m-0">{{ "do_nhoe" | translate }}</p>
            <nz-input-number
              [nzMin]="0"
              [nzMax]="10"
              [nzStep]="1"
              [ngModel]="config['style_filter']['filter_blur']"
              (ngModelChange)="updateFilter($event)"
              (nzBlur)="updateClass()"
            >
            </nz-input-number>
          </nz-row>
          <nz-slider
            [nzMin]="0"
            [nzMax]="10"
            [ngModel]="config['style_filter']['filter_blur']"
            (ngModelChange)="updateFilter($event)"
            (nzOnAfterChange)="updateClass()"
          >
          </nz-slider>
        </ng-container>
      </li>

      <!-- Kiểu viền -->
      <li
       
        nz-submenu
        nzTitle="{{ 'kieu_vien' | translate }}"
        [(nzOpen)]="openMap.menu3.menuChild.menu5"
        (nzOpenChange)="openHandler('menu5')"
      >
        <app-borders-config [elementChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [borderClass]="class[staticdata.is_favorited ? '+icon': '-icon']"
          [id_object]="objectChoosing._id"
        >
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p
            class="m-0 title-border my-2"
            (click)="openViewAll(styles_field[0])"
          >
            {{ "mo_rong" | translate }} &#8594;
          </p>
        </div>
      </li>

      <!-- Lật hình  -->
      <li
     
        nz-submenu
        nzTitle="{{ 'lat_hinh' | translate }}"
        [(nzOpen)]="openMap.menu3.menuChild.menu6"
        (nzOpenChange)="openHandler('menu6')"
      >
        <div class="editor-field-body">
          <div class="mb-3">
            <div class="field-row-sub">
              <div style="display: flex; gap: 4px; width: 100%">
                <span
                  nz-button
                  nzType="primary"
                  nzSize="default"
                  (click)="handleSetTransform('y')"
                  class="btn_transform"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z"
                    ></path>
                  </svg>
                  <p class="m-0">{{ "ngang" | translate }}</p>
                </span>
                <button
                  nz-button
                  nzType="primary"
                  nzSize="default"
                  (click)="handleSetTransform('x')"
                  class="btn_transform"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z"
                    ></path>
                  </svg>
                  <p class="m-0">{{ "doc" | translate }}</p>
                </button>
              </div>
            </div>
          </div>
          <div class="field-row mb-3">
            <div class="field-row-sub">
              <div style="display: flex; gap: 4px; width: 100%">
                <button
                  nz-button
                  nzType="primary"
                  nzSize="default"
                  class="btn_transform"
                  (click)="handleSetTransform('-z')"
                >
                  <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                  <p class="m-0">{{ "trai" | translate }}</p>
                </button>
                <button
                  nz-button
                  nzType="primary"
                  nzSize="default"
                  class="btn_transform"
                  (click)="handleSetTransform('z')"
                >
                  <span
                    nz-icon
                    nzType="rotate-right"
                    nzTheme="outline"
                  ></span>
                  <p class="m-0">{{ "phai" | translate }}</p>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mr-2 mb-4 mt-4 view-more"
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          "
        >
          <p
            class="discover_text"
            (click)="openViewAll(styles_field[2])"
            style="cursor: pointer; text-align: left; margin: 0"
          >
            {{ "mo_rong" | translate }} &#8594;
          </p>
        </div>
      </li>

      <!-- Cấu hình hiệu ứng -->
      <li
       
        nz-submenu
        nzTitle="{{ 'hieu_ung' | translate }}"
        [(nzOpen)]="openMap.menu3.menuChild.menu8"
        (nzOpenChange)="openHandler('menu8')"
      >
        <app-choose-animations-config
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="staticdata"
          [cursorClass]="class[staticdata.is_favorited ? '+icon': '-icon']"
          [effect_hover]="effect_hover"
          [customize]="customize"
          [type]="'object'"
        >
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!--Cấu hình hiệu ứng  -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
        [device]="device"
        [class]="class"
        [borderRadiusClass]="class[staticdata.is_favorited ? '+icon': '-icon']"
        [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 2">
      <app-animations-config
        [staticdata]="staticdata"
        [id_object]="objectChoosing._id"
        [customize]="customize"
        [device]="device"
      >
      </app-animations-config>
    </div>
    <!-- Cấu hình chi tiết lật hình -->
    <div class="editor-field-body p-0 mt-2" *ngIf="currentViewAll.index == 3">
      <div class="editor-field-body">
        <div class="field-row">
          <p style="font-weight: 500; font-size: 16px">
            {{ "lat_hinh" | translate }}
          </p>
          <div class="field-row-sub">
            <div style="display: flex; gap: 4px; width: 100%">
              <span
                nz-button
                nzType="primary"
                nzSize="default"
                (click)="handleSetTransform('y')"
                class="btn_transform"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z"
                  ></path>
                </svg>
                <p class="m-0">{{ "ngang" | translate }}</p>
              </span>
              <button
                nz-button
                nzType="primary"
                nzSize="default"
                (click)="handleSetTransform('x')"
                class="btn_transform"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z"
                  ></path>
                </svg>
                <p class="m-0">{{ "doc" | translate }}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item mt-2" style="min-height: 32px">
            <p class="m-0">{{ "ngang" | translate }}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_rotateY"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_rotateY"
            (nzOnAfterChange)="updateObject()"
            (ngModelChange)="SetTransform()"
          >
          </nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{ "doc" | translate }}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_rotateX"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_rotateX"
            (nzOnAfterChange)="updateObject()"
            (ngModelChange)="SetTransform()"
          >
          </nz-slider>
        </div>
      </div>
      <br />
      <!-- Xoay hình ảnh -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div style="justify-content: space-between; align-items: center">
            <p class="mt-1" style="font-weight: 500; font-size: 16px">
              {{ "xoay_hinh" | translate }}
            </p>
            <div
              style="display: flex; justify-content: space-between; gap: 4px"
            >
              <button
                class="btn_transform"
                nz-button
                nzType="primary"
                nzSize="default"
                (click)="handleSetTransform('-z')"
              >
                <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                <p class="m-0">{{ "trai" | translate }}</p>
              </button>
              <button
                nz-button
                nzType="primary"
                nzSize="default"
                class="btn_transform"
                (click)="handleSetTransform('z')"
              >
                <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                <p class="m-0">{{ "phai" | translate }}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item" styl="min-height: 32px">
            <p class="m-0">{{ "xoay" | translate }}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_rotateZ"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_rotateZ"
            (nzOnAfterChange)="updateObject()"
            (ngModelChange)="SetTransform()"
          ></nz-slider>
        </div>
      </div>
      <br />
      <!-- Cấu hình Độ nghiêng -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div class="item">
            <p class="m-0" style="font-weight: 500; font-size: 16px">
              {{ "do_nghieng" | translate }}
            </p>
          </div>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{ "ngang" | translate }}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_skewY"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_skewY"
            (nzOnAfterChange)="updateObject()"
            (ngModelChange)="SetTransform()"
          ></nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{ "doc" | translate }}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_skewX"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_skewX"
            (nzOnAfterChange)="updateObject()"
            (ngModelChange)="SetTransform()"
          ></nz-slider>
        </div>
      </div>
    </div>
  </div>
</div>
